// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"7538":"recorder","7642":"94a7ad86","9983":"profiler"}[chunkId] || chunkId) + "." + {"544":"72ba26019dc71578","6203":"f3062d719393c25a","7538":"3c401dda183d4a81","7642":"f36fc43404a30bf2","9983":"05fad7d9f9d47f4f"}[chunkId] + ".js";
};